import { render, staticRenderFns } from "./BasicTags.vue?vue&type=template&id=578bcbff"
import script from "./BasicTags.vue?vue&type=script&lang=js"
export * from "./BasicTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports